"use strict";

var _toConsumableArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _console;

var _package = _interopRequireDefault(require("../package.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** `..` path imported from `.ts` would broken the output dir structure */


var pkgInfo = ["%c".concat("Furegame ".concat(_package.default.version), "%c"), "%c".concat(_package.default.author, "%c"), '\n', "%c".concat(_package.default.license, "%c"), "%c".concat(_package.default.homepage, "%c"), '\n'].join('');
var padding = 'padding: 0.2em 0.5em;';
var style = ["background: #6cf; color: #fff; ".concat(padding), ''].concat(["color: #6cc; ".concat(padding), ''], [], ["background: #e00; color: #9ff; ".concat(padding), ''], ["".concat(padding), ''], []);
if (typeof window === 'undefined') console.info(pkgInfo.replace(/%c/g, ' * ')); // eslint-disable-line no-console
else (_console = console).info.apply(_console, [pkgInfo].concat(_toConsumableArray(style))); // eslint-disable-line no-console